export default __webpack_public_path__ + "static/media/docs-illustration-min.52e08877.svg";